<script>
	 import { Router, link, Route } from "svelte-routing";
	import OffersSafetyMattersPriorBooking from '../components/OffersSafetyMattersPriorBooking.svelte';
</script>

<div class="image-background">
    <h1 class="header_text_wrapper text-left"><span>Camping</span><span class="separator"></span></h1>
</div>
<div id="primary" class="content-area container-fluid">
    <main id="main" class="site-main main-content content-width">
        <article id="post-5122" class="post-5122 page type-page status-publish hentry">
            <div class="page-content top-0 bottom-35">
                <div class="vc_row wpb_row vc_row-fluid">
                    <div class="wpb_column vc_column_container vc_col-sm-12">
                        <div class="vc_column-inner">
                            <div class="wpb_wrapper">
                                <div class="vc_empty_space" style="height: 15px;"><span class="vc_empty_space_inner"></span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vc_row wpb_row vc_row-fluid accomodation_box">
                    <div class="wpb_column vc_column_container vc_col-sm-12">
                        <div class="vc_column-inner">
                            <div class="wpb_wrapper">
                                <div class="wpb_raw_code wpb_content_element wpb_raw_html">
                                    <div class="wpb_wrapper">
                                        <div class="calluna-room-carousel mist_accomodation">
                                            <div class="room-carousel" data-items="3">
                                                <!-- <div class="room-item accomodation_boxes">
                                                    <a href="/camping-tent" title="Camping (Tent)" class="room-pic" use:link target="_top">
                                                        <img src="/images/Tent3.jpg" alt="" style="width: 100%;" />
                                                        <div class="room-content-wrapper">
                                                            <span class="overlay"></span>
                                                            <div class="room-title">
                                                                <h3>Camping (Tent)</h3>
                                                            </div>
                                                            <div class="room-excerpt"></div>
                                                            <div class="room-price-wrapper">
                                                                <div class="room-price style-2">
                                                                    <span>Per Person</span>
                                                                    <span class="inline-price">₹ 2,650 </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div> -->
                                                <div class="room-item accomodation_boxes">
                                                    <a href="/camping-hut" title="Camping (Hut)" class="room-pic" use:link target="_top">
                                                        <img src="/images/camping_3.jpg" alt="" style="width: 100%;" />
                                                        <div class="room-content-wrapper">
                                                            <!-- <span class="overlay"></span> -->
                                                            <div class="room-title">
                                                                <h3>Camping (Hut)</h3>
                                                            </div>
															<div style="color: #fff; margin: 80px 0 20px 0; display: flex; justify-content: center; align-items: center;">
															</div>
                                                            <div class="room-excerpt"></div>
                                                            <div class="room-price-wrapper">
                                                                <div class="room-price style-2">
                                                                    <span>Per Person</span>
                                                                    <span class="inline-price">₹ 3000 </span>
                                                                </div>
																<a style="color: #fff;" class="" href="https://www.mangomist.com/campinghut.html" target="_blank" contenteditable="false">View Details</a>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <OffersSafetyMattersPriorBooking />
                <div class="vc_row wpb_row vc_row-fluid" style="height: 0;">
                    <div class="wpb_column vc_column_container vc_col-sm-12"></div>
                </div>
            </div>
        </article>
    </main>
</div>

<style>
	.image-background {
        background: url("../images/Accomodation.jpg") no-repeat center;
    }
	.mist_accomodation .room-carousel .room-item {
		display: inline-block;
		margin-bottom: 10px;
		margin-left: 0;
		margin-right: 0;
		padding-top: 8px;
		padding-bottom: 8px;
		position: relative;
	}
	.mist_accomodation .room-carousel .room-item {
		height: 345px;
		width: 515px;
	}
	.mist_accomodation .room-item {
		height: 300px;
	}
	.accomodation_boxes {
		-moz-border-bottom-colors: none;
		-moz-border-left-colors: none;
		-moz-border-right-colors: none;
		-moz-border-top-colors: none;
		background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
		border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4) rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
		border-image: none;
		border-radius: 25px;
		box-shadow: 8px 8px 8px #888888;
		width: 48% !important;
	}

	.accomodation_boxes .room-pic > img {
		border-radius: 25px;
		height: 330px;
		padding-left: 10px;
		padding-right: 10px;
		width: 560px;
	}
	.accomodation_boxes .room-pic > img {
		border-radius: 25px;
		padding-left: 10px;
		padding-right: 10px;
		width: 560px;
	}

	.room-carousel .room-content-wrapper {
		height: 100%;
		padding: 30px;
		position: absolute;
		top: 0;
		width: 100%;
	}

	.accomodation_boxes .room-content-wrapper .overlay {
		background-color: rgba(15, 36, 83, 0.4);
		border-radius: 15px;
		bottom: 7px;
		left: 10px;
		margin: 0;
		padding: 0;
		position: absolute;
		right: 10px;
		top: 7px;
		transition: all 0.3s ease 0s;
	}

	.room-carousel .room-title {
		display: block;
		position: relative;
		text-align: center;
		top: 40%;
		transition: all 0.3s ease 0s;
	}

	.mist_accomodation .room-title {
		top: 10%;
	}

	.mist_accomodation .room-excerpt {
		top: -35px;
	}
	.room-carousel .room-excerpt {
		opacity: 0;
		position: relative;
		top: 22%;
		transition: opacity 0.3s ease 0s;
	}
	.room-carousel .room-excerpt {
		opacity: 0;
		position: relative;
		top: 22%;
		transition: opacity 0.3s ease 0s;
	}

	.mist_accomodation .room-carousel .room-excerpt {
		top: 10px;
	}

	.room-carousel .room-price-wrapper {
		bottom: 45px;
		left: 0;
		position: absolute;
		right: 0;
		text-align: center;
	}

	.room-carousel .room-content-wrapper:hover .room-price, .room-carousel .room-price.style-2 {
		background-color: #907650;
		border-color: #907650;
		color: #fff;
	}
	.room-carousel .room-price {
		border-radius: 3px;
		display: inline-block;
		font-family: Lato;
		font-size: 1.125rem;
		font-weight: 500;
		letter-spacing: 0.1rem;
		padding: 14px 36px;
		text-transform: uppercase;
		transition: all 0.3s ease 0s;
	}

	.room-carousel .room-content-wrapper:hover .room-price, .room-carousel .room-price.style-2 {
		background-color: #907650;
		border-color: #907650;
		color: #fff;
	}
	.room-carousel .room-price {
		border-radius: 3px;
		display: inline-block;
		font-family: Lato;
		font-size: 1.125rem;
		font-weight: 500;
		letter-spacing: 0.1rem;
		padding: 14px 36px;
		text-transform: uppercase;
		transition: all 0.3s ease 0s;
	}

	.room-carousel .room-title h3 {
		box-shadow: 0 0 2px 1px #fff;
		color: #fff;
		padding-bottom: 10px;
		padding-top: 10px;
	}

	.room-carousel .room-content-wrapper:hover .room-title {
		top: 0;
	}

	.room-carousel .room-content-wrapper:hover .overlay {
		background-color: rgba(150, 122, 80, 0.7);
	}

	.accomodation_boxes:nth-child(2n) {
		margin-bottom: 30px !important;
		margin-left: 30px !important;
	}

	#primary {
		background: rgba(0, 0, 0, 0) url("../images/gpattern-opacity-1.png") repeat scroll 0 0;
	}
	
	.wpb_content_element {
		margin-bottom: 35px;
	}

	@media only screen and (max-width: 768px) {
        .accomodation_boxes {
            margin-bottom: 30px !important;
			margin-left: 0 !important;
            width: 100% !important;
        }

		.accomodation_boxes:nth-child(2n) {
			margin-left: 0 !important;
		}

		.mist_accomodation .room-carousel .room-item {
			height: 250px;
		}

		.accomodation_boxes .room-pic >img {
			height: 100%;
		}
    }
</style>